import { render } from "./PlayerButton.vue?vue&type=template&id=49e3cb54"
import script from "./PlayerButton.vue?vue&type=script&lang=js"
export * from "./PlayerButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__